function ElevioLogoSVG() {
  return (
    <svg
      width="50"
      height="50"
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip_elevio_logo)">
        <rect x="5" y="5" width="40" height="40" rx="9" fill="#49B583" />
        <circle
          cx="25"
          cy="19.5"
          r="7"
          stroke="white"
          strokeWidth="3.6"
          fill="none"
        />
        <path
          d="M 14.25 30.75 Q 25 24.5 35.75 30.75"
          stroke="white"
          strokeWidth="3.6"
          strokeLinecap="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip_elevio_logo">
          <rect x="5" y="5" width="40" height="40" rx="9" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ElevioLogoSVG;
